/**
 * ResumeMetric - Salary Calculator
 * Pure compensation math and conversions.
 * @module tools/salaryCalculator
 */

export function calculateSalary(input) {
    const { amount, frequency } = input;
    const hoursPerWeek = input.hoursPerWeek || 40;
    const daysPerWeek = input.daysPerWeek || 5;
    const vacationDays = input.vacationDays || 0;

    if (!amount || amount <= 0 || !frequency) return null;

    const weeksPerYear = 52;
    const monthsPerYear = 12;
    
    // Effective working time (used for daily/hourly rates)
    const workDaysPerYear = (weeksPerYear * daysPerWeek) - vacationDays;
    const workHoursPerYear = (weeksPerYear * hoursPerWeek) - (vacationDays * (hoursPerWeek / daysPerWeek));

    let annual;
    switch (frequency) {
        case 'annual': annual = amount; break;
        case 'monthly': annual = amount * monthsPerYear; break;
        case 'weekly': annual = amount * weeksPerYear; break; 
        case 'daily': annual = amount * workDaysPerYear; break;
        case 'hourly': annual = amount * workHoursPerYear; break;
        default: throw new Error('Invalid frequency');
    }

    return {
        annual: annual,
        monthly: annual / monthsPerYear,
        weekly: annual / weeksPerYear,
        daily: annual / workDaysPerYear,
        hourly: annual / workHoursPerYear,
        meta: { 
            hoursPerWeek, 
            daysPerWeek, 
            vacationDays, 
            workDaysPerYear: Math.round(workDaysPerYear), 
            workHoursPerYear: Math.round(workHoursPerYear) 
        }
    };
}

export function calculateSalaryIncrease(oldSalary, newSalary) {
    if (oldSalary <= 0 || newSalary <= 0) return null;

    const difference = newSalary - oldSalary;
    const percentage = (difference / oldSalary) * 100;

    return {
        difference,
        percentage,
        isIncrease: difference > 0,
        isDecrease: difference < 0,
        monthlyDifference: difference / 12,
        annualDifference: difference
    };
}
